"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addLabelForNonSemanticRoles = void 0;
/**
 * List of aria-roles that apply "presentation" to descendants, which strips
 * math markup of its semantic meaning, which makes it inaccessible to screen
 * readers and other assistive technology.
 *
 * Taken from this rule from WAI-ARIA 1.2:
 * https://www.w3.org/TR/wai-aria-1.2/#tree_exclusion
 */
const roles = [
    "button",
    "checkbox",
    "img",
    "menuitemcheckbox",
    "menuitemradio",
    "meter",
    "option",
    "progressbar",
    "radio",
    "scrollbar",
    "separator",
    "slider",
    "switch",
    "tab",
    // Combobox is NOT included in the WAI-ARIA 1.2 list of aria-roles that apply "presentation" to descendants
    "combobox",
];
const nodeHasRoleIn = (dom, roles) => roles.some((role) => dom.matches(`[role=${role}]`));
const addLabelForNonSemanticRoles = (node, container, labelFn) => {
    let parent = container;
    while (parent && !nodeHasRoleIn(parent, roles)) {
        parent = parent.parentElement;
    }
    if (parent) {
        // Fire and forget. We don't want to block rendering.
        labelFn().then((label) => {
            node.setAttribute("aria-label", label);
        });
    }
};
exports.addLabelForNonSemanticRoles = addLabelForNonSemanticRoles;
